<template>
  <div class="controlPanelCom">
    <div class="titleBox">
      <h6>{{ list.name }}</h6>
      <p>额定功率:{{ list.loadPower }}kw</p>
      <p>实时功率:{{ list.power }}kw</p>
    </div>
    <div class="contentBox">
      <template v-if="list.deviceInfos.length">
        <div class="leftMenuBox">
          <ul class="leftMenu">
            <li
              v-for="(v, i) in list.deviceInfos"
              :key="i"
              :class="{ rowBox: true, activeLi: activeIndex == i }"
              @click="activeIndex = i"
            >
              <el-button
                v-if="
                  list.name === '风机盘管' &&
                  v.detailsType !== 'OVERALL_PLANNING'
                "
                style="margin-left: 5px"
                size="mini"
                icon="el-icon-delete"
                circle
                @click="deleteAsset(v)"
              ></el-button>
              <p>
                {{ v.name }}
              </p>
              <el-switch
                v-model="v.state"
                style="margin-right: 10px"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch"
              >
              </el-switch>
            </li>
          </ul>
          <el-button
            size="mini"
            style="width: 100%"
            v-if="list.name == '风机盘管'"
            @click="addListBtn(list)"
            ><i class="el-icon-plus"></i>添加独立控制盘管</el-button
          >
        </div>

        <ul class="rightPanel">
          <template
            v-if="
              list.name == '风机盘管' &&
              list.deviceInfos[activeIndex].detailsType !== 'OVERALL_PLANNING'
            "
          >
            <el-radio-group
              v-model="list.deviceInfos[activeIndex].detailsType"
              style="margin: 10px"
            >
              <el-radio :label="'NOT_PARTICIPATING'">不参与策略</el-radio>
              <el-radio :label="'INDEPENDENCE'">独立策略</el-radio>
            </el-radio-group>
          </template>
          <template v-if="list.deviceInfos[activeIndex].detailsList.length">
            <li
              v-for="(v, i) in list.deviceInfos[activeIndex].detailsList"
              :key="i"
            >
              <p>
                {{ v.name }} <span>{{ v.unit }}</span>
              </p>
              <el-input-number
                style="margin-right: 20px"
                size="mini"
                v-model="v.value"
                @change="
                  (currentValue, oldValue) =>
                    handleChange(currentValue, oldValue, v)
                "
                :min="0"
                :max="100"
                :precision="1"
              >
              </el-input-number>
            </li>
            <el-radio-group
              v-if="list.name == '风机盘管'"
              size="mini"
              v-model="list.deviceInfos[activeIndex].model"
            >
              <el-radio
                v-for="(v, i) in list.deviceInfos[activeIndex].modeList"
                :key="i"
                :label="v.value"
                border
                >{{ v.name }}</el-radio
              >
            </el-radio-group>
          </template>
          <li v-else><p style="margin: 0 auto">暂无参数</p></li>
        </ul>
      </template>
      <el-empty v-else class="emptyBox" description="暂无数据"></el-empty>
    </div>
    <el-dialog
      title="添加独立控制盘管"
      :visible.sync="dialogVisible"
      width="30%"
      v-if="dialogVisible"
    >
      <el-select
        style="width: 100%"
        v-model="value"
        filterable
        value-key="id"
        placeholder="请选择"
        multiple
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.name"
          :value="item"
        >
        </el-option>
      </el-select>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="increaseList">添 加</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    list: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeIndex: 0,
      timer: null,
      dialogVisible: false,
      options: [],
      value: [],
    };
  },
  methods: {
    // 删除独立控制盘管
    deleteAsset(item) {
      this.$confirm("删除后该盘管将不可独立控制", "删除独立控制盘管", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = this.list.deviceInfos.filter((v) => v.id !== item.id);
          this.list.deviceInfos = arr;
          this.activeIndex = 0;
        })
        .catch(() => {});
    },
    changeSwitch(value) {
      if (this.list.activeType === "机房") {
        this.$emit("getChangeValue", {
          id: this.list.deviceInfos[this.activeIndex].id,
          controlType: value === 1 ? "ON" : "OFF",
          key: "RunSign",
          value: null,
        });
      }
    },
    handleChange(currentValue, oldValue, item) {
      // console.log(currentValue, oldValue, item);
      if (this.list.activeType === "机房") {
        clearTimeout(this.timer);
        this.timer = null;
        this.timer = setTimeout(() => {
          this.$emit("getChangeValue", {
            id: this.list.deviceInfos[this.activeIndex].id,
            controlType: "CHANGE",
            key: item.key,
            value: currentValue,
          });
        }, 1000);
      }
    },
    async addListBtn(data) {
      this.value = [];
      this.options = [];
      this.dialogVisible = true;
      // console.log(data);
      let id = data.deviceInfos.find((v) => {
        return v.detailsType === "OVERALL_PLANNING";
      }).id;
      let res = await api.ACRSearchDevicesList({
        assetId: id,
        deviceTypes: "风机盘管",
        deviceName: "",
      });
      // console.log(res);
      if (res && res.data.code == 200) {
        let arr = res.data.data.filter(
          (x) => !this.list.deviceInfos.some((y) => y.id === x.id)
        );
        this.options = arr;
      }
    },
    increaseList() {
      let item = this.list.deviceInfos.find((v) => {
        return v.detailsType === "OVERALL_PLANNING";
      });
      let arr = [];
      if (this.value.length) {
        this.value.map((v) => {
          let newItem = this._.cloneDeep(item);
          newItem.name = v.name;
          newItem.id = v.id;
          newItem.detailsType = "INDEPENDENCE";
          arr.push(newItem);
        });
      }
      this.list.deviceInfos.push(...arr);
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.controlPanelCom {
  width: 100%;
  // height: 100%;
  height: 300px;
  // padding: 20px 20px 10px 20px;
  .titleBox {
    width: 100%;
    height: 50px;
    @include setFlexStart;
    border-bottom: 1px solid #e9e9e9;
    h6 {
      font-size: 15px;
      margin-left: 20px;
    }
    p {
      margin: 0 10px;
    }
  }
  .contentBox {
    width: 97%;
    margin: 0 auto;
    height: 245px;
    @include setFlexBetween;
    align-items: flex-start;
    .emptyBox {
      width: 100%;
      height: 90%;
    }
    .leftMenuBox {
      width: 37%;
      height: 98%;
      @include setFlexColumn;
      justify-content: space-between;
      .leftMenu {
        width: 100%;
        height: 80%;
        overflow-y: auto;
        margin-top: 10px;
        // background: salmon;
        .rowBox {
          width: 100%;
          padding: 7px 0;
          border-bottom: 1px solid #e9e9e9;
          @include setFlexBetween;
          p {
            text-align: center;
            text-indent: 10px;
          }
        }
        .rowBox:hover {
          background: rgba(40, 204, 203, 0.5);
          color: #fff;
        }
        .activeLi {
          background: rgba(40, 204, 203, 0.7) !important;
          color: #fff;
        }
      }
    }

    .rightPanel {
      width: 60%;
      height: 96%;
      overflow-y: auto;
      ::v-deep .el-radio.is-bordered {
        margin: 0 5px 5px 0;
      }
      ::v-deep .el-radio-group .is-bordered {
        .el-radio__input {
          display: none;
        }
      }
      li {
        width: 90%;
        padding: 8px 0;
        margin: 10px auto;
        background: #e9e9e9;
        @include setFlexBetween;
        p {
          margin-left: 10px;
          span {
            font-size: 12px;
            color: #999;
          }
        }
        // .btnBox {
        //   margin-right: 10px;
        //   font-size: 22px;
        //   @include setFlexBetween;
        //   h6 {
        //     font-size: 20px;
        //     margin: 0 12px;
        //     span {
        //       font-size: 12px;
        //       color: #999;
        //     }
        //   }
        //   .btn {
        //     font-weight: bold;
        //     cursor: pointer;

        //     &:hover {
        //       color: #28cccb;
        //     }
        //   }
        // }
      }
    }
  }
}
</style>
